module.exports = __webpack_public_path__ + "static/media/parktag_logo.cd8cfc97.png";